import { Dispatch } from "redux";
import api from "../../api/api";
import {
    setSchoolById, setloading, seterror, resetschoolbyid
} from "../reducers/getSchoolByIDReducer";

const schoolById = (id: any,token:any) => async (dispatch: Dispatch) => {
   dispatch(setloading(true));
   try {
     const result = await api
       .get(
        `/super-admin/get-school/${id}/`,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Token ${token}`
          },
        }
       )
       
       if(result){
        dispatch(setloading(false));
        if (result.data?.status === 200) {
            dispatch(setSchoolById(result.data.data));
          }
          else {
            dispatch(seterror(result.data?.message ?? "Something Went Wrong!"));
          }
       }
   }
   catch (error: any) {
    dispatch(seterror(error.response.data.message));
   }
}

export { schoolById, resetschoolbyid} 

